import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import modules from './modules'
import mutations from './mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  mutations,
  getters,
  modules: modules.reduce((storeModules, storeModule) => {
    storeModules[storeModule.storeKey] = storeModule.store
    return storeModules
  }, {}),
  strict: process.env.NODE_ENV !== 'production',
})
